import React from 'react';

import { Accent, Box } from '@nerdwallet/currency';

import styles from './new-feature-tag.module.less';

interface Props {
  textSize?: React.ComponentProps<typeof Accent>['size'];
}

const NewFeatureTag: React.FC<Props> = ({ textSize }) => (
  <Box className={styles.newText}>
    <img
      // Exclude animated GIF from Chromatic
      data-chromatic="ignore"
      src="https://www.nerdwallet.com/cdn/my-nerdwallet/weekly-insights/sparkle-left.gif"
      alt="Left Sparkle"
      className={styles.sparkle}
    />
    <Accent size={textSize}>new</Accent>
    <img
      // Exclude animated GIF from Chromatic
      data-chromatic="ignore"
      src="https://www.nerdwallet.com/cdn/my-nerdwallet/weekly-insights/sparkle-right.gif"
      alt="Right Sparkle"
      className={styles.sparkle}
    />
  </Box>
);

export default NewFeatureTag;
